const exchangeRates = (amount: number, toRate: number) => (amount / toRate) * 1

function getConvertededPrice(price: number, currency: 'RUB' | 'UZS' | 'USD', exchangeRatesData: { rub: string; usd: string }) {
  if (currency === 'RUB') {
    return Number(exchangeRates(price, Number(exchangeRatesData?.rub || 1))?.toFixed(2))
  } else if (currency === 'USD') {
    return Number(exchangeRates(price, Number(exchangeRatesData?.usd || 1))?.toFixed(2))
  }

  return price
}

export { exchangeRates, getConvertededPrice }